import type { HttpClient } from '../client/http';
import type { DocResponse, ListResponse } from '../client/types';
import type { ListOpts } from './collection';

export interface SharedMethods {
  /** @throws SdkError on network/5xx (retried 3x). */
  list(opts?: ListOpts): Promise<ListResponse>;
  /** @throws SdkError on network/5xx (NOT retried — fail-fast). @notIdempotent */
  create(args: { data: unknown }): Promise<DocResponse>;
}

export function createShared(client: HttpClient, appId: string) {
  return function shared(name: string): SharedMethods {
    const base = `/api/app/${appId}/db/${name}/shared`;
    return {
      list(opts: ListOpts = {}): Promise<ListResponse> {
        const query: Record<string, string | number | undefined> = {
          limit: opts.limit ?? 50,
          orderBy: opts.orderBy ?? 'created_at',
          order: opts.order ?? 'desc',
        };
        if (opts.cursor) query.cursor = opts.cursor;
        return client.request<ListResponse>('GET', base, { query });
      },
      create(args) {
        return client.request<DocResponse>('POST', base, { body: args });
      },
    };
  };
}
